import * as requestFromServer from "./PersonAssignmentCrud";
import { callTypes, personAssignmentSlice } from "./PersonAssignmentSlice";

const {actions} = personAssignmentSlice;

export const getList = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getList()
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getTeacherAndNoticeGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getTeacherAndNoticeGroups(queryParams)
    .then(response => {
      dispatch(actions.peopleFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllTeacherAndNoticeGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllTeacherAndNoticeGroups(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getNoticeGroups = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getNoticeGroups()
    .then(response => {
      dispatch(actions.noticeGroupsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getTeachers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getTeachers(queryParams)
    .then(response => {
      dispatch(actions.peopleFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getBranches = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getBranches()
    .then(response => {
      dispatch(actions.filtersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getPersonIds = (noticeGroupId, receipentType) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getPersonIds(noticeGroupId, receipentType)
    .then(response => {
      dispatch(actions.personIdsFetched(response.data));
    })
      
    .catch(error => {
      
    });
};

export const savePeople = (receipentType, noticeGroupId, personIds) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .savePeople(receipentType, noticeGroupId, personIds)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanList = () => dispatch => {
  return dispatch(actions.listCleaned());
};

export const cleanPersonIds = () => dispatch => {
  return dispatch(actions.personIdsCleaned());
};

export const cleanPeople = () => dispatch => {
  return dispatch(actions.peopleCleaned());
};